module.exports = __webpack_public_path__ + "static/media/physicalHealth.b1718435.jpg";